import React from 'react';
import { markdownToHtml } from '../../helpers/starterHelpers';
import '../../styles/components/AsperaMarkdownRender.scss';
export class AsperaMarkdownRender extends React.Component {
    render() {
        const { className, markdown } = this.props;
        return React.createElement("div", { className: `aspera-markdown-render ${className ? className : ''}`, dangerouslySetInnerHTML: { __html: markdownToHtml(markdown) } });
    }
}
